import {
  HydrationBoundary,
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';
import React, { ReactNode } from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { Store } from 'redux';

import { TranslationsProvider } from './modules/translations';

declare global {
  interface Window {
    __REACT_QUERY_STATE__?: any;
  }
}

export default function Provider({
  children,
  store,
  queryClient,
}: {
  children: ReactNode;
  store: Store;
  queryClient: QueryClient;
}) {
  const dehydratedState =
    typeof window !== 'undefined' && window.__REACT_QUERY_STATE__
      ? window.__REACT_QUERY_STATE__
      : undefined;

  if (typeof window !== 'undefined' && window.__REACT_QUERY_STATE__) {
    delete window.__REACT_QUERY_STATE__;
  }

  return (
    <QueryClientProvider client={queryClient}>
      <ReduxProvider store={store}>
        <HydrationBoundary state={dehydratedState}>
          <TranslationsProvider>{children}</TranslationsProvider>
        </HydrationBoundary>
      </ReduxProvider>
    </QueryClientProvider>
  );
}
